<template>
  <div :class="computedClass" :style="{backgroundImage: `url(${url})`}" />
</template>

<script>
export default {
  name: 'QmAvatar',
  props: {
    isFloat: Boolean,
    size: {
      type: String,
      // @values: [ 'small', 'medium', 'large', 'huge']
      default: 'medium',
    },
    url: {
      type: String,
      default: 'http://statics01.readland.cn/profile_default.svg',
    },
  },
  computed: {
    computedClass() {
      return {
        'qm-avatar': true,
        [`size-${this.size}`]: true,
        'is-float': this.isFloat,
      }
    },
  },
}
</script>

<style lang="scss"></style>
